import { useMemo } from 'react';
import { messages } from 'shared/constants/countryNames';
import { useGetBusinessCountries } from 'shared/data/walletsKyc/v1';

export const useFormData = () => {
    const { data: businessCountries, isLoading: isLoadingBusinessCountries } = useGetBusinessCountries();

    const countries = useMemo(
        () =>
            (businessCountries?.items || []).map((country) => ({
                id: country.countryCode,
                name: messages[country.countryCode as keyof typeof messages] || country.countryCode,
            })),
        [businessCountries?.items]
    );

    return {
        countries,
        isLoadingBusinessCountries,
    };
};
